import PaymentDetails from './payment-details.vue';

export default PaymentDetails;
